module.exports = __webpack_public_path__ + "img/0.e3d0d288.jpg";